import React from 'react';
import {
    Typography,
    TextField,
    Checkbox,
    FormControlLabel,
    Paper, IconButton
} from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import withShipment from "../../withShipment";
import { userInfoSelector, usersSelector } from "../../redux/selectors/auth";
import { getUsers } from "../../redux/actions/auth";

import "./Task.css";
import CustomToolbar from "../global/CustomToolbar";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {TODO} from "../global/Server/endpoints";
import {apiRequest} from "../../redux/actions/api";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import {Autocomplete} from "@material-ui/lab";
import {statusOptions, priorityOptions, getStatusFromProgress} from "./constants";

import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import 'react-quill/dist/quill.snow.css';
import EditIcon from "@material-ui/icons/Edit";
import {SwipeableTaskCard} from "./SwipeableTaskCard";
import TaskForm from "./TaskForm";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import {DEFAULT_PDF_ZOOM, getByteArray} from "../global/constants";
import PDFViewer from "../global/PDFViewer";
import {GetApp} from "@material-ui/icons";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";

class Task extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      todos: [],
      newTodo: {
        title: '',
        description: '',
        dueDate: new Date(),
        assignedTo: '',
        priority: 'Low',
        status: 'Not Started',
        progress: 0,
        companyId: this.props.userInfo.companyId,
        comments:  []

      },
      editingTodo: null,
        showForm: false,

      // feedback bar states
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',

      filters: {
        status: "ALL",
        priority: "ALL",
        myTask: false,
        overdue: false,
      },

      //attachments and comments:

         newFiles: [],
            files: [],
            viewingFile: {},
            viewing: false,
            fileType: null,
            attachment: null,

            deletingAttachment: false,
            attachmentLoading: false,
               scale: DEFAULT_PDF_ZOOM,




    };

      this.hiddenFileInput = React.createRef()
      this.fileUpload = this.fileUpload.bind(this)
  }

  async componentDidMount() {
    this.props.getUsers();
    await this.fetchTodos()
  }

  openForm = (todo = null) => {
      if (todo) {
        const isOwner = todo.createdBy === this.props.userInfo.userId;
        this.setState({
          showForm: true,
          editingTodo: { ...todo, isOwner },
          newTodo: { ...todo, dueDate: new Date(todo.dueDate) }
        });
      } else {
        this.setState({
          showForm: true,
          editingTodo: null,
          newTodo: {
            title: '',
            description: '',
            dueDate: new Date(),
            assignedTo: '',
            priority: 'Low',
            status: 'Not Started',
            progress: 0,
            companyId: this.props.userInfo.companyId,
            comments: []
          }
        });
      }
    };

    goBack = () => {
      this.setState({
        showForm: false,
        editingTodo: null
      });
    };

  /* ---------------- Feedback Bar ------------------- */

  openFeedbackBar = (status,message) => {
    this.setState({feedbackStatus: status, feedbackMessage: message,feedbackBarOpen: true})
  }

   closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage:''}, () => {
    })
  }

  handleProgressChange = (value) => {
  this.setState(prev => ({
    newTodo: {
      ...prev.newTodo,
      progress: value,
      status: getStatusFromProgress(value), // automatically update status
    }
  }));
};

  /* ------------------ API Calls -------------------- */
  fetchTodos = () => {
    this.props.apiRequest({
      key: 'task/list',
      endpoint: TODO.LIST,
      data: { companyId: this.props.userInfo.companyId },
      silent: true,
      onSuccess: (payload) => {
        // Map API response to UI-friendly structure
        const todos = (payload?.todos || []).map((todo) => {
          const assignedUser = this.props.allUsers.find(
            (u) => u.userId === todo.assignedTo,
          );
          const createdBy = this.props.allUsers.find(
            (u) => u.userId === todo.createdBy,
          );

          return {
            id: todo.todoId,
            title: todo.title,
            description: todo.description,
            dueDate: new Date(todo.dueDate),
            status: todo.status,
            priority: todo.priority,
            progress: todo.progress || 0,
            owner: createdBy ? this.getFullName(createdBy) : 'Unknown',
            assignees: assignedUser ? [this.getFullName(assignedUser)] : [],
            assignedTo: todo.assignedTo,
            createdBy: todo.createdBy,
            comments: todo.comments || [],
            files: todo.files || [],
            color:
              todo.priority === 'Critical'
                ? 'red'
                : todo.priority === 'High'
                ? 'orange'
                : todo.priority === 'Medium'
                ? 'blue'
                : todo.priority === 'Low'
                ? 'gray'
                : 'gray',
          };
        });

        this.setState({ todos });
      },
      onError: () => this.openFeedbackBar('error', 'Failed to load tasks'),
    });
  };

    isOwner = (todo) => {
        return todo?.createdBy === this.props.userInfo.userId;
    };



    validateTodo = () => {
      const { title, assignedTo, dueDate, priority, status,description } = this.state.newTodo;

      const errors = [];

      if (!title?.trim()) errors.push('Title');
      if (!assignedTo) errors.push('Assigned User');
      if (!dueDate) errors.push('Due Date');
      if (!priority) errors.push('Priority');
      if (!status) errors.push('Status');
      if (!description?.trim()) errors.push('Description');

      if (errors.length) {
        this.openFeedbackBar(
          'error',
          `${errors.join(', ')} ${errors.length > 1 ? 'are' : 'is'} required`
        );
        return false;
      }

      return true;
    };

  createTodo = () => {

    if (!this.validateTodo()) return;

    const { newTodo, editingTodo, newFiles } = this.state;

    if (!newTodo.title || !newTodo.assignedTo) {
      this.openFeedbackBar("error", "Title and Assigned User are required");
      return;
    }

    const endpoint = editingTodo ? TODO.UPDATE : TODO.SAVE;
    const payload = editingTodo
      ? { ...newTodo, todoId: editingTodo.todoId, attachments: newFiles, comments: newTodo.comments }
      : { ...newTodo, attachments: newFiles, comments: newTodo.comments };

    this.props.apiRequest({
      key: editingTodo ? 'task/update' : 'task/save',
      endpoint,
      data: payload,
      silent: true,
      onSuccess: (response) => {
        if (response?.success) {
          this.openFeedbackBar("success", response.message || 'Task Created');
          this.setState({ editingTodo: null, showForm: false, newFiles: [], files: [] });
          this.fetchTodos();
        } else {
          this.openFeedbackBar("error", response?.message || "Error saving task");
        }
      },
      onError: (err) => this.openFeedbackBar("error", err || "Error saving task"),
    });
  };

  deleteTodo = (todoId) => {
    this.props.apiRequest({
      key: 'task/delete',
      endpoint: TODO.DELETE,
      data: { todoId },
      silent: true,
      onSuccess: (response) => {
        this.openFeedbackBar("success", response?.message || 'Task deleted');
        this.fetchTodos();
      },
      onError: () => this.openFeedbackBar("error", "Failed to delete task"),
    });
  };

  /* --------------------------------------------------*/

  handleInputChange = (field, value) => {
    this.setState(prev => ({
      newTodo: { ...prev.newTodo, [field]: value }
    }));
  };

  toggleExpand = (id) => {
    this.setState(prev => ({
      expandedId: prev.expandedId === id ? null : id
    }));
  };

    getFullName = (user) => {
      if (!user) return '';
      return [user.firstname, user.lastname].filter(Boolean).join(' ');
    };


   //attachments and comments

    fileUpload(e) {
        if (e.target.files.length === 0) return
        let file = e.target.files[0]
        let fileReader = new FileReader();


        fileReader.onload = (e) => {
            new Uint8Array(e.target.result)
        }
        fileReader.readAsArrayBuffer(file)
    }


    //attachment
    handleAttachmentPreview = (file, index) => {
        const fileType = this.getFileType(file);

        this.setState({viewing: true, viewingFile: file, fileType, attachmentLoading: true, showForm: false});

        this.props.apiRequest({
            key: `task/attachment/${file.path}`,
            endpoint: TODO.PREVIEW_ATTACHMENT,
            data: { path: file.path },
            silent: true,
            onSuccess: (payload) => {
                if (payload?.bytes) {
                    const mimeType = fileType === 'pdf' ? 'application/pdf' : 'image/png';
                    const blob = new Blob([Uint8Array.from(payload.bytes)], { type: mimeType });
                    const localURL = URL.createObjectURL(blob);
                    this.setState({
                        attachmentLoading: false,
                        viewingFile: { ...file, localURL },
                        attachment: payload.bytes,
                    });
                } else {
                    this.setState({ attachmentLoading: false });
                }
            },
            onError: () => {
                this.openFeedbackBar("error", "Failed to load file");
                this.setState({ attachmentLoading: false });
            },
        });
    }

    getFileType = (file) => {
        const ext = file.displayName.split('.').pop().toLowerCase();
        if (ext === 'pdf') return 'pdf';
        if (['jpg','jpeg','png','gif'].includes(ext)) return 'image';
        return 'other';
    }


   handleGeneralFileDelete = (file, index) => {
        const updatedNewFiles = [...this.state.newFiles]
        updatedNewFiles.splice(index, 1)
        if ("localURL" in file) {
            URL.revokeObjectURL(file.localURL)
        }
        this.setState({
            newFiles: updatedNewFiles
        })
    }

   handleGeneralFileAdd = (file) => {
        const updatedNewFiles = [...this.state.newFiles]
        let newFile = {
            localURL: URL.createObjectURL(file),
            displayName: file.name,
            byteArray: getByteArray(file),
            type: file.type
        }
        this.setState({
            newFiles: [...updatedNewFiles, newFile],
        })
    }

   handleCommentUpdate = (valueOrArray, submit = false) => {
  if (submit) {
    this.setState(prev => ({
      newTodo: { ...prev.newTodo, comments: valueOrArray, commentsInput: '' }
    }));
  } else {
    this.setState(prev => ({
      newTodo: { ...prev.newTodo, commentsInput: valueOrArray }
    }));
  }
};

    // Edit a comment
handleCommentEdit = (index, value) => {
  this.setState(prev => {
    const updatedComments = [...prev.newTodo.comments];
    if (updatedComments[index]) {
      updatedComments[index].comment = value;
    }
    return {
      newTodo: { ...prev.newTodo, comments: updatedComments }
    };
  });
};

// Delete a comment
handleCommentDelete = (index) => {
  this.setState(prev => {
    const updatedComments = [...prev.newTodo.comments];
    updatedComments.splice(index, 1);
    return {
      newTodo: { ...prev.newTodo, comments: updatedComments }
    };
  });
};


   downloadAttachment = () => {
        let blob = new Blob([Uint8Array.from(this.state.attachment)], { type: "application/pdf" });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.state.viewingFile.displayName ? this.state.viewingFile.displayName : this.state.name
        link.click();

        window.URL.revokeObjectURL(link.href)
   }

   setZoom(zoom) {
        let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2)
        this.setState({
            scale: newScale
        })
    }

  render() {
    const { todos } = this.state;
    const { userInfo } = this.props;

    let headerButtons = [];

    if (this.state.showForm) {
      // Form mode buttons
      headerButtons = [
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.setState({ showForm: false }),
          title: 'Go Back',
        },
      ];
    } else if (this.state.viewing && !this.state.deletingAttachment) {
      // View mode buttons
      headerButtons = [
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.setState({ viewing: false, viewingFile: {}, deletingAttachment: false, showForm:true}),
          title: 'Back',
          disabled: false,
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: <span style={{ padding: '5px', marginTop: '5px' }}>{Math.round(this.state.scale * 100)}%</span>,
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        },
        {
          icon: <GetApp />,
          handler: () => this.downloadAttachment(),
          title: 'Download PDF',
        },
        // {
        //   icon: <DeleteIcon />,
        //   handler: () => this.setState({ deletingAttachment: true }),
        //   title: 'Delete',
        //   disabled: false,
        // },
      ];
    } else {
      // Default buttons when not in form or viewing mode
      headerButtons = [
        {
          icon: <AddCircleIcon />,
          handler: () => this.openForm(),
          title: 'Create Task',
        },
      ];
    }

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>

          <FeedbackBar
            open={this.state.feedbackBarOpen}
            handleClose={this.closeFeedbackBar}
            severity={this.state.feedbackStatus}
            message={this.state.feedbackMessage}
           />

          <CustomToolbar
              title={
                  this.state.showForm
                    ? (this.state.editingTodo ? 'Update Task' : 'Create Task')
                    : 'Tasks'
                }
              backTitle={this.state.showForm ? 'Back to Tasks' : 'Back To Menu'}
              onBack={this.state.showForm ? this.goBack : undefined}
              headerButtons={headerButtons}
          />


        {this.state.showForm ? (
              <TaskForm
                 newTodo={this.state.newTodo}
                allUsers={this.props.allUsers}
                isEditing={Boolean(this.state.editingTodo)}
                isOwner={this.state.editingTodo?.isOwner ?? true}
                onChange={this.handleInputChange}
                onProgressChange={this.handleProgressChange}
                onSave={this.createTodo}
                files={this.state.newTodo.files}
                newFiles={this.state.newFiles}
                handleGeneralFileAdd={this.handleGeneralFileAdd}
                handleGeneralFileDelete={this.handleGeneralFileDelete}
                handleAttachmentPreview={this.handleAttachmentPreview}
                comments={this.state.newTodo.comments}
                handleCommentUpdate={this.handleCommentUpdate}
                currentUser={this.props.userInfo}
                handleCommentEdit={this.handleCommentEdit}
                handleCommentDelete={this.handleCommentDelete}

              />
            ) : this.state.viewing && this.state.viewingFile ? (
                this.state.fileType === 'pdf' ? (
                  <PDFViewer
                    data={this.state.viewingFile.bytes || this.state.attachment}
                    scale={this.state.scale}
                  />
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '80vh',
                    }}
                  >
                    <img
                       src={this.state.viewingFile?.localURL}
                        alt={this.state.viewingFile?.displayName || 'Attachment'}
                      style={{
                        maxWidth: '90%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                )
              )

            : (
                <div className="root">

                    <Paper elevation={0} className="filters-bar" style={{ padding: 16 }}>
                      <div
                          className="filters-left"
                          style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 16,
                          }}
                      >
                          {/* First Row: Status + Priority */}

                          <Autocomplete
                              options={priorityOptions}
                              getOptionLabel={(option) => option.label}
                              value={priorityOptions.find(opt => opt.label === this.state.filters.priority) || null}
                              onChange={(e, newValue) =>
                                  this.setState({ filters: { ...this.state.filters, priority: newValue?.label || "ALL" } })
                              }
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      label="Priority"
                                      variant="outlined"
                                      style={{ minWidth: 120 }}
                                      InputProps={{
                                          ...params.InputProps,
                                          startAdornment: this.state.filters.priority !== "ALL" ? (
                                              <div
                                                  style={{
                                                      width: 16,
                                                      height: 16,
                                                      borderRadius: "50%",
                                                      backgroundColor:
                                                          priorityOptions.find(o => o.label === this.state.filters.priority)?.color ||
                                                          "#ccc",
                                                      display: "inline-block",
                                                      marginRight: 8,
                                                      verticalAlign: "middle",
                                                  }}
                                              />
                                          ) : null,
                                      }}
                                  />
                              )}
                          />

                          <Autocomplete
                              options={statusOptions}
                              getOptionLabel={(option) => option.label}
                              value={statusOptions.find(opt => opt.label === this.state.filters.status) || null}
                              onChange={(e, newValue) =>
                                  this.setState({ filters: { ...this.state.filters, status: newValue?.label || "ALL" } })
                              }
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      label="Status"
                                      variant="outlined"
                                      style={{ minWidth: 120 }}
                                      InputProps={{
                                          ...params.InputProps,
                                          startAdornment: this.state.filters.status !== "ALL" ? (
                                              <div
                                                  style={{
                                                      width: 16,
                                                      height: 16,
                                                      borderRadius: "50%",
                                                      backgroundColor:
                                                          statusOptions.find(o => o.label === this.state.filters.status)?.color ||
                                                          "#ccc",
                                                      display: "inline-block",
                                                      marginRight: 8,
                                                      verticalAlign: "middle",
                                                  }}
                                              />
                                          ) : null,
                                      }}
                                  />
                              )}
                          />



                          {/* Second Row: My Tasks + Overdue */}
                          <div
                              style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 16,
                                  width: "100%",
                                  marginTop: 8,
                              }}
                          >
                              <FormControlLabel
                                  control={
                                      <Checkbox
                                          color="primary"
                                          checked={this.state.filters.myTask}
                                          onChange={(e) =>
                                              this.setState({
                                                  filters: { ...this.state.filters, myTask: e.target.checked },
                                              })
                                          }
                                      />
                                  }
                                  label="My Tasks"
                              />

                              <FormControlLabel
                                  control={
                                      <Checkbox
                                          color="primary"
                                          checked={this.state.filters.overdue}
                                          onChange={(e) =>
                                              this.setState({
                                                  filters: { ...this.state.filters, overdue: e.target.checked },
                                              })
                                          }
                                      />
                                  }
                                  label="Overdue"
                              />
                          </div>
                      </div>
                  </Paper>

                    {todos
                        .filter(task => {
                          const { status, priority, myTask, overdue } = this.state.filters;

                          if (status !== "ALL" && task.status !== status) return false;
                          if (priority !== "ALL" && task.priority !== priority) return false;

                            if (myTask) {
                                const myFullName = `${userInfo.firstname} ${userInfo.lastname}`;
                                if (!task.assignees.includes(myFullName)) return false;
                            }

                            if (overdue) {
                                const today = new Date();
                                today.setHours(0,0,0,0);
                                const due = new Date(task.dueDate);
                                due.setHours(0,0,0,0);

                                if (due.getTime() >= today.getTime()) return false; // not overdue
                            }

                          return true;
                        })
                        .map((task, index) => {
                            const expanded = this.state.expandedId === task.id;

                            return (<div className="task-row">

                                <div className="task-number">{index + 1}</div>

                            <SwipeableTaskCard
                                key={task.id}
                                task={task}
                                canDelete={task.createdBy === userInfo.userId}
                                onDelete={(id) => this.deleteTodo(id)}
                                onClick={() => this.toggleExpand(task.id)}
                              >
                                <div
                                  className={`task-card ${
                                    expanded ? 'expanded' : ''
                                  }`}
                                >


                                  {/* LEFT COLOR BAR */}
                                  <div
                                    className="left-bar"
                                    style={{ backgroundColor: task.color }}
                                  />

                                  <div className="task-body">
                                    {/* Edit */}
                                    <div className="task-actions">
                                      <IconButton
                                        color="primary"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.openForm(task);
                                        }}
                                      >
                                        <EditIcon />
                                      </IconButton>
                                    </div>

                                    {/* HEADER */}
                                    <div className="task-header">
                                      <div className="title-row">
                                        <span
                                          className="status-dot"
                                          style={{
                                            backgroundColor: task.color,
                                          }}
                                        />
                                        <Typography className="task-title">
                                          {task.title}
                                        </Typography>
                                      </div>

                                      <Typography className="due">
                                        Due {task.dueDate.toLocaleDateString()}
                                      </Typography>
                                    </div>

                                    {/* COLLAPSED VIEW */}
                                    {!expanded && (
                                      <div className="collapsed-row">
                                        <div className="left-meta">
                                          <span
                                            className={`status-pill ${task.status.replace(
                                              ' ',
                                              '-'
                                            )}`}
                                          >
                                            {task.status}
                                          </span>

                                          <div className="avatars">
                                            {task.assignees.map((a, i) => (
                                              <div className="avatar">
                                                {a?.charAt(0) || '?'}
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {/* EXPANDED VIEW */}
                                    {expanded && (
                                      <>
                                        <div className="expanded-tags">
                                          {task.priority === 'Critical' && (
                                            <span className="priority-pill">
                                              Critical
                                            </span>
                                          )}
                                          <span
                                            className={`status-pill ${task.status.replace(
                                              ' ',
                                              '-'
                                            )}`}
                                          >
                                            {task.status}
                                          </span>

                                          <div className="progress">
                                            <div className="progress-bg">
                                              <div
                                                className="progress-fill"
                                                style={{
                                                  width: `${task.progress}%`,
                                                }}
                                              />
                                            </div>
                                            <span>{task.progress}%</span>
                                          </div>
                                        </div>

                                        <div className="people-row">
                                          <span className="people-item">
                                            <AssignmentTurnedInIcon className="people-icon" />
                                            <b>{task.owner}</b>
                                          </span>

                                          <span className="people-item">
                                            <PeopleOutlineIcon className="people-icon" />
                                            {task.assignees.join(', ')}
                                          </span>
                                        </div>

                                        {task.description && (
                                          <Typography
                                            className="description"
                                            dangerouslySetInnerHTML={{
                                              __html: task.description,
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </SwipeableTaskCard>
                                </div>
                            );
                          }
                    )}

              </div>

            )}

      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
  allUsers: usersSelector(state),
});

const actionCreators = {
  getUsers,
  apiRequest,
};

export default withShipment({ mapStateToProps, actionCreators }, Task);
